* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: 0;
  margin: 0;
}
